import DotNetObject = DotNet.DotNetObject;
import { JobCategory } from '@crimsontide/core/client/interfaces';

export const JobCategoryService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobCategories: JobCategory[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobCategoriesByJobAreaIds = async (jobAreaIds: string[]): Promise<JobCategory[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<JobCategory[]>('GetByJobAreaIdsAsync', jobAreaIds);
    } else {
      throw 'Job Category DotNet Object Reference has not yet been implemented';
    }
  };

  const getJobCategories = async (useCache: boolean = true): Promise<JobCategory[]> => {
    if (useCache && cachedJobCategories != null)
      return cachedJobCategories;

    if (dotNetObj) {
      cachedJobCategories = await dotNetObj.invokeMethodAsync<JobCategory[]>('GetAllAsync');
      return cachedJobCategories;
    } else {
      throw 'Job Category DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobCategoriesByJobAreaIds,
    getJobCategories,
  };
})();
